import React from 'react';
import PropTypes from 'prop-types';
import { styles, Typography } from '../../index';
import classNames from 'classnames';

const WellText = props => {
  const classes = useStyles();
  return (
    <Typography
      variant={'body1'}
      className={classNames(classes.root, props.className)}>
      {props.children}
    </Typography>
  );
};

WellText.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
};

const useStyles = styles.makeStyles(
  (theme) => ({
    root: {
      textAlign: 'center',
      fontStyle: 'normal',
      fontWeight: 'normal',
      letterSpacing: '0.5px',
      fontSize: 16,
      color: '#272527'
    },
  })
);


export default WellText;
